<template>
    <div class="container">
        <div class="members__top">
            <BackButton/>


            <div class="members__action">

                <router-link to="/studios/unapproved-members" class="members__btn btn btn-sm btn-h40 btn-gradient btn-gradient_white">
                   <span>{{$t('form.unverified_clients')}}</span>
                </router-link>

                <router-link to="/studios/members/new-member" class="members__btn btn btn-sm btn-h40 btn-gradient">
                    <span>{{$t('form.register_member')}}</span>
                </router-link>
            </div>



        </div>
        <div class="attention">
            <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
            <div class="attention__text">
                <p v-html="$t('studio.view-members.intro_title')"></p>
                <router-link class="members-link" to="/studios/inactive-members">{{$t('studio.view-members.intro_here')}}</router-link>

            </div>
        </div>

        <Table
            :tableHead="memberHead"
            :tableBody="memberData"
            :tableData="tableData"
            :allowTooltip="true"
            :isHover="false"
            :requestFunction="getClientsList"
            moreMode="table"
            :isMapOpen="false"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { getClientsList } from "@/api/studioServices";
    import Table from "@/elements/Table/Table";

    export default {
        components: {
            Table
        },
        methods: {
          goToMembers() {
              this.$router.push('/studios/members/new-member')
          }
        },

        computed: {
          ...mapGetters([
              'tableData',
          ]),

            memberHead() {
              return [
                  {
                      name: 'gender',
                      adaptiveMode: 'mobile',
                      width: '43px',
                  },
                  {
                      name: 'firstName',
                      adaptiveMode: 'mobile',
                  },
                  {
                      name: 'lastName',
                      adaptiveMode: 'mobile',
                  },
                  {
                      name: 'email',
                      adaptiveMode: 'none',
                      width: '210px'
                  },
                  {
                      name: 'passCode',
                      adaptiveMode: 'tablet',
                  },
                  {
                      name: 'daysRemaining',
                      adaptiveMode: 'none',
                      width: '29px'
                  },
                  {
                      name: 'dateExpirationAt',
                      adaptiveMode: 'none',
                      width: '106px'
                  },
                  {
                      name: 'tooltip',
                      adaptiveMode: 'none',
                      width: '25px'
                  },
              ]
            },

            memberData() {
              let arr = [];

              this.tableData.data && this.tableData.data.forEach(item => {
                  arr.push({
                      gender: item.is_male,
                      firstName: item.first_name,
                      lastName: item.last_name,
                      email: item.email,
                      passCode: item.pass_code ? item.pass_code.code : '-',
                      daysRemaining: item.pass_code ? item.pass_code.days_remaining: '-',
                      dateExpirationAt: item.pass_code ? item.pass_code.expiration_at : '-',
                      tooltip: {
                          id: item.id,
                          expired_id: item.pass_code ? item.pass_code.id: undefined,
                          days_remaining: item.pass_code ? item.pass_code.days_remaining: undefined,
                          is_expired: item.pass_code? item.pass_code.is_expired : undefined
                      }
                  })
              });

              return arr;
            }
        },

        data() {
            return {
                getClientsList: getClientsList
            }
        },

        async created() {
            await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: getClientsList});

        }
    }
</script>
<style lang="sass" scoped>
    .members
        &__top
            display: flex
            justify-content: space-between
            align-items: center
            +sm
                flex-direction: column
                align-items: start
            &::v-deep
                .back__button
                    +sm
                        margin: 0!important
        &__action
            +sm
                width: 100%
                margin-top: 16px
            +xs
                display: flex
                flex-direction: column
            .btn + .btn
                margin-left: 16px
                +xs
                    margin-left: 0
        &__btn
            border-radius: 4px
            &:before,
            &:after
                border-radius: 4px
            +xs
                &:first-of-type
                    order: 2
                    margin-top: 16px
                &:last-of-type
                    order: 1
</style>

